var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.basketItems.LatestIdeaBook &&
    _vm.basketItems.LatestIdeaBook.IdeabookCoverImage
    ? _c("div", { staticClass: "ideabook-recommendations-wrapper" }, [
        _c("div", { staticClass: "ideabook-recommendations-heading" }, [
          _c("h5", { staticClass: "primary-heading" }, [
            _vm._v(
              _vm._s(
                _vm.$resourceString["myBasket.IdeaBook.Recommendations.Title"]
              ) + ":"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "primary-description" }, [
            _vm._v(
              _vm._s(_vm.$resourceString["myBasket.IdeaBook.Label.IdeaBook"]) +
                " " +
                _vm._s(_vm.basketItems.LatestIdeaBook.IdeabookPublicationYear)
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "primary-description" }, [
            _vm._v(_vm._s(_vm.basketItems.LatestIdeaBook.IdeabookName))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ideabook-recommendations-details" }, [
          _c(
            "div",
            { staticClass: "ideabook-recommendations-checkbox-label" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ideaBookChecked,
                    expression: "ideaBookChecked"
                  }
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "add-ideabook" },
                domProps: {
                  checked: Array.isArray(_vm.ideaBookChecked)
                    ? _vm._i(_vm.ideaBookChecked, null) > -1
                    : _vm.ideaBookChecked
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.ideaBookChecked,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.ideaBookChecked = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.ideaBookChecked = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.ideaBookChecked = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "add-ideabook" }
                },
                [
                  _vm._v(
                    "\n               " +
                      _vm._s(
                        _vm.$resourceString[
                          "myBasket.IdeaBook.Label.AddIdeaBookToBasket"
                        ]
                      ) +
                      "                    \n           "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ideabook-recommendations-coverimage" }, [
            _c("img", {
              attrs: {
                src: _vm.basketItems.LatestIdeaBook.IdeabookCoverImage.replace(
                  "~",
                  ""
                ),
                alt: ""
              },
              on: { error: _vm.handleImageError }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }